import { Card, CardBody, Col } from "reactstrap";
import { ModalTitle } from "../../../../Constants/Constants";
import { BasicModalSubTitle } from "../../../../Data/UiKits/Modal";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ScrollingModal from "./ScrollingModal";
import SimpleModal from "./SimpleModal";
import TooltipModal from "./TooltipModal/TooltipModal";
import BerlinModal from "./BerlinModal/BerlinModal";

const BasicModal = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={ModalTitle} span={BasicModalSubTitle} />
        <CardBody className="badge-spacing">
          <SimpleModal />
          <ScrollingModal />
          <TooltipModal />
          <BerlinModal />
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicModal;
